import { createSelector, createSlice } from '@reduxjs/toolkit';
import qs from 'qs';
import * as R from 'ramda';
import http from 'utils/http';
import { generateSearchParams } from 'utils/helpers/fetch';

const initialState = {
  error: '',
  originatorsList: [],
  pending: false,
};

// Reducers
const reducers = {
  fetchOriginatorsError(state, { payload }) {
    return R.assoc('error', payload, state);
  },
  fetchOriginatorsPending(state, { payload }) {
    return R.assoc('pending', payload, state);
  },
  fetchOriginatorsSuccess(state, { payload }) {
    return R.assoc('originatorsList', payload, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'originators',
  reducers,
});

// Selectors

const originatorsListSelector = state => state.pto.originators.originatorsList;

export const getOriginatorOptions = createSelector(originatorsListSelector, originators =>
  originators.map(({ customerIdName, customerName }) => ({
    label: `${customerIdName} ${customerName}`,
    value: `${customerIdName}`,
  }))
);

const { fetchOriginatorsPending, fetchOriginatorsSuccess, fetchOriginatorsError } = actions;

// Actions
let fetchController;
export function fetchOriginators() {
  return (dispatch, getState) => {
    const { currentAffiliate } = getState().pto.searchPtos;
    const formattedAffiliate = currentAffiliate
      ? {
          affiliate: {
            companyCustomerIdName: currentAffiliate.customerIdName,
            dataCompanyId: currentAffiliate.dataCompanyId,
          },
        }
      : null;
    const paramString = qs.stringify(
      generateSearchParams(getState().pto.searchPtoFilters, formattedAffiliate),
      { allowDots: true, encode: false }
    );
    dispatch(fetchOriginatorsPending());
    if (fetchController) fetchController.abort();
    fetchController = new AbortController();
    const { signal } = fetchController;
    http
      .get(`/product-transfer-orders/get-unique-originators-list?${paramString}`, { signal })
      .then(res => {
        dispatch(fetchOriginatorsError(''));
        dispatch(fetchOriginatorsSuccess(res.data));
        dispatch(fetchOriginatorsPending(false));
      });
  };
}

export default reducer;
